import { type User } from '@kalos/kalos-rpc';
import { toast } from '@kalos/ui';
import { redirect } from '@tanstack/react-router';

import { permitAdminCheck } from '../../tools/permissionChecks';

// Shared by every /permitting route, including the pages that render outside the
// list layout (create group, permit detail), so none of them skips the check.
export const guardPermitAdminRoute = (user: User) => {
  if (permitAdminCheck(user)) return;
  toast({
    title: 'You do not have permission to view this page',
    description: 'Please contact your administrator if you believe this is an error',
    variant: 'destructive',
  });
  throw redirect({ to: '/' });
};
